import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_stmt_account_event_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  run_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  duration_day: fromDatatype.VarcharArrayDatatypeInterface;
  recurring_event_params: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  rrule: fromDatatype.VarcharDatatypeInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  run_type: fromDatatype.VarcharDatatypeInterface;
  statement_type: fromDatatype.VarcharDatatypeInterface;
  printable_format_hdr_guid: fromDatatype.GuidDataFieldInterface;
  run_status: fromDatatype.VarcharDatatypeInterface;
  group_guid_01: fromDatatype.GuidDataFieldInterface;
  soa_settings_json: fromDatatype.JsonDatatypeInterface;
  recipient_emails: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_stmt_account_event_hdr_RowClass
  implements bl_fi_stmt_account_event_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  run_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  duration_day: fromDatatype.VarcharArrayDatatypeInterface;
  recurring_event_params: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  rrule: fromDatatype.VarcharDatatypeInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  run_type: fromDatatype.VarcharDatatypeInterface;
  statement_type: fromDatatype.VarcharDatatypeInterface;
  printable_format_hdr_guid: fromDatatype.GuidDataFieldInterface;
  run_status: fromDatatype.VarcharDatatypeInterface;
  group_guid_01: fromDatatype.GuidDataFieldInterface;
  soa_settings_json: fromDatatype.JsonDatatypeInterface;
  recipient_emails: fromDatatype.JsonDatatypeInterface;
}